<template>
  <div class="emd-box__header">
    <div class="emd-flex _justify_space-between _align_center">
      <div class="emd-flex-item">
        <h2 class="emd-text _size_section _color_primary">{{ title }}</h2>
      </div>
      <div class="emd-flex-item">
        <div class="emd-flex _justify_space-between">
          <a :href="appUrlOnStore" v-if="viewAppOnStore" class="emd-btn _color_primary _type_text">{{$t('edit.review.view_the_app')}}</a>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmdBoxHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    viewAppOnStore: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    publicAppKey () {
      return this.$route.params.publicAppKey
    },
    appUrlOnStore () {
      return `${process.env.VUE_APP_STORE_URL}/apps/dev/${this.publicAppKey}`
    }
  }
}
</script>
